<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



<script>
  import Vue from 'vue';
  import {Backtop,Tag,Button,ButtonGroup,Upload,Dialog,Message,Container,Tabs,TabPane,Form,FormItem, Input,InputNumber, Link,Icon, Carousel,CarouselItem, Divider,Menu,Submenu,MenuItem,MenuItemGroup, Breadcrumb,
  BreadcrumbItem, Radio,Cascader,CascaderPanel,
  RadioGroup,Loading,Image,Badge,Popover,
  RadioButton,Pagination,Col,Row,Select, Option,OptionGroup, Table,TableColumn,Checkbox,CheckboxButton,CheckboxGroup,MessageBox,Progress,} from 'element-ui';
  Vue.use(Button);
  Vue.use(Backtop);
  Vue.use(Tag);
  Vue.use(Popover);
  Vue.use(Cascader);
  Vue.use(CascaderPanel);
  Vue.use(ButtonGroup);
  Vue.use(Upload);
  Vue.use(Dialog);
  Vue.use(Tabs);
  Vue.use(TabPane);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Input);
  Vue.use(InputNumber);
  Vue.use(Link);
  Vue.use(Icon);
  Vue.use(Carousel);
  Vue.use(CarouselItem);
  Vue.use(Divider);
  Vue.use(Menu);
  Vue.use(Submenu);
  Vue.use(MenuItem);
  Vue.use(Breadcrumb);
  Vue.use(BreadcrumbItem);
  Vue.use(MenuItemGroup);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(RadioButton);
  Vue.use(Pagination);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(OptionGroup);
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Checkbox);
  Vue.use(CheckboxButton);
  Vue.use(CheckboxGroup);
  Vue.use(Loading.directive);
  Vue.use(Image);
  Vue.use(Badge);
  Vue.use(Progress);

  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$message = Message;
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;

  export default {
  }


</script>



// WEBPACK FOOTER //
// src/App.vue